import { tourBackButton, tourCustomButton, tourExitButton, tourNextButton } from '../data/tour-buttons';
import { type TourStepDefinition } from '../data/tour-config';
import { TourService } from '../services/tour/tour.service';

export function getMedicalRecordTour(tourService: TourService): TourStepDefinition[] {
  return [
    {
      id: 'medicalRecordTourIntro',
      buttons: [tourExitButton(tourService, 'Skip Tour'), tourNextButton('Start Tour')],
      title: 'Welcome to Your Medical Record!',
      text: "Let's take a quick tour of the different sections available to you.",
    },
    {
      id: 'newSinceLastVisitInfo',
      attachTo: {
        element: '#newSinceLastVisit',
        on: 'bottom',
      },
      scrollTo: false,
      buttons: [tourExitButton(tourService), tourBackButton(), tourNextButton('Next (1 of 4)')],
      title: 'New Since Last Visit',
      text: () =>
        `<div class="flex flex-col gap-6">
      <span>Stay up to date at a glance. This section surfaces your latest results, upcoming appointments, and anything else new since your last visit.</span>
      </div>`,
    },
    {
      id: 'medicalHistoryInfo',
      attachTo: {
        element: '#medicalHistory',
        on: 'bottom',
      },
      scrollTo: false,
      buttons: [tourExitButton(tourService), tourBackButton(), tourNextButton('Next (2 of 4)')],
      title: 'Medical History',
      text: () =>
        `<div>Everything in one place. View your health summary, medications, and immunizations to get a full picture of your health history.
      </div>`,
    },
    {
      id: 'diagnosticsInfo',
      attachTo: {
        element: '#diagnosticRecords',
        on: 'top',
      },
      scrollTo: true,
      buttons: [tourExitButton(tourService), tourBackButton(), tourNextButton('Next (3 of 4)')],
      title: 'Diagnostic Records',
      text: () =>
        `<div>Dig into the details. Access your lab results and medical reports, and tap any item to view the full information.
      </div>`,
    },
    {
      id: 'administrativeInfo',
      attachTo: {
        element: '#administrative',
        on: 'bottom',
      },
      scrollTo: true,
      buttons: [tourExitButton(tourService), tourBackButton(), tourNextButton('Done (4 of 4)')],
      title: 'Administrative',
      text: () =>
        `<div>Important documents, easy to find. Locate letters and other documents from your care team, like sick notes and no-show letters.
      </div>`,
    },
    {
      id: 'medicalRecordTourOutro',
      buttons: [tourCustomButton('Got it', 'primary', () => tourService.complete())],
      title: "You're All Set!",
      text: () =>
        `<div class="flex flex-col gap-6">
        <span>You're all set! You can access this tour again anytime from the help menu.</span>
      </div>`,
    },
  ];
}
